export const meetings = 'meetings';

export const webinars = 'webinars';
